var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-path-outer",
    d: "M0.718654 14.8227C0.740298 7.34052 6.77549 1.34014 14.2577 1.36179C21.7398 1.38343 27.7402 7.41862 27.7185 14.9008C27.6969 22.3829 21.6617 28.3833 14.1795 28.3617C6.69739 28.34 0.697009 22.3048 0.718654 14.8227Z",
    stroke: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-path-inner",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3869 14.302L14.8036 14.2801L14.8256 6.69676C14.8266 6.34676 14.5939 6.11275 14.2439 6.11174C13.8939 6.11073 13.6599 6.34338 13.6589 6.69338L13.637 14.2767L6.05366 14.2547C5.70366 14.2537 5.46965 14.4864 5.46864 14.8364C5.46763 15.1864 5.70028 15.4204 6.05028 15.4214L13.6336 15.4433L13.6116 23.0266C13.6106 23.3766 13.8433 23.6107 14.1933 23.6117C14.5433 23.6127 14.7773 23.38 14.7783 23.03L14.8002 15.4467L22.3835 15.4687C22.7335 15.4697 22.9676 15.237 22.9686 14.887C22.9696 14.537 22.7369 14.303 22.3869 14.302Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleBlue);
export default __webpack_public_path__ + "static/media/plus-circle-blue.92d98a048f8074191f90a81e5aade488.svg";
export { ForwardRef as ReactComponent };